// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 21H2V19H22V21Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 16H2V14H22V16Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M17 11H2V3H17V11Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-highlighted-block-filled')
export default class HighlightedBlockFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'highlighted-block-filled',
    }
  }
}
